import React from "react";
import appConfig from "../config";

const AdminLoginRedirector = () => {
  window.location.href = `${appConfig.route[appConfig.environment]}/adminlogin`;
  return <div></div>;
};

export default AdminLoginRedirector;
